import { useEffect, useState } from "react"
import { FaEllipsis, FaPhone, FaPlus } from "react-icons/fa6"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import api from "../config/backend"
import { SpinnerCircular } from "spinners-react"
import { toast } from "react-toastify"
import "./css/RecurringInvoiceList.css"
import DefaultProfile from "../assets/DefaultProfile.jpg"

// Calculate total amount of a invoice
const calcualteTotal = (invoice) => {
    let total = 0

    const items = invoice.items

    items.forEach(item => {
        total += (item.quantity * item.rate)
    })

    const subtotal = total

    if (invoice.discount) {
        if (invoice.discount.ispercentage) {
            total = total - (total * invoice.discount.value / 100)
        } else {
            total = total - invoice.discount.value
        }
    }

    if (invoice.adjustment) {
        total = total + invoice.adjustment.value
    }

    return { total, subtotal }
}

const RecurringInvoiceList = ({ invoicesList, setInvoicesList, setCreateInvoice }) => {
    const [activeInvoice, setActiveInvoice] = useState(0)
    const [generatedInvoices, setGeneratedInvoices] = useState([])
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()

    const token = localStorage.getItem("_crm__token")

    const handleToggleStatus = async (status) => {
        const response = await axios.post(`${api}/Accounting/Recurring/toggle-active`, {
            token,
            invoicehash: invoicesList[activeInvoice].hash,
            status
        })

        if (response.data.success) {
            setInvoicesList(prev => {
                return prev.map(item => {
                    if (item.hash === invoicesList[activeInvoice].hash) {
                        return {...item, active: status}
                    }
                    return item
                })                
            })
        } else {
            toast.error(response.data.message)
        }
    }

    const fetchAutoGeneratedInvoices = async () => {
        setLoading(true)

        const { data, status } = await axios.post(`${api}/Accounting/Recurring/generated-invoices`, {
            token,
            invoicehash: invoicesList[activeInvoice].hash
        })

        setLoading(false)

        if (data.success) {
            setGeneratedInvoices(data.invoices)
        }
    }

    useEffect(() => {
        fetchAutoGeneratedInvoices()
    }, [activeInvoice])

    const selectedInvoice = invoicesList[activeInvoice]

    const { total } = calcualteTotal(selectedInvoice)

    function currencyFormat(number) {
        return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    return (
        <div className="_7fzc">
            <div className="sidebar app-new-quotes-sidebar">
                <div className="header">
                    <div>Recurring Invoices</div>
                    <div className="hatchet-scab">
                        <button onClick={() => setCreateInvoice(true)}><FaPlus /> New</button>
                    </div>
                </div>
                <div className="reacting-eggs">
                    {invoicesList.map((invoice, index) => {
                        const { total, subtotal } = calcualteTotal(invoice)

                        return (
                            <div
                                key={index}
                                className={activeInvoice === index ? "stubby-hex active" : "stubby-hex"}
                                onClick={() => setActiveInvoice(index)}
                            >
                                <div className="spinner-them">
                                    <div className="customer-name">{invoice.customer.firstname} {invoice.customer.lastname}</div>
                                    <div>{invoice.customer.currency.icon}{total}</div>
                                </div>
                                <div className="spinner-them">
                                    <div>
                                        Next invoice on
                                        {invoice.nextgenerate ? <span style={{ fontSize: "10px", marginLeft: "4px" }}>{new Date(invoice.nextgenerate).toDateString()}</span> : <span style={{ fontSize: "10px", marginLeft: "4px", backgroundColor: "rgb(174, 174, 174)", color: "white", padding: "4px 6px", borderRadius: "2px" }}>Expired</span>}
                                    </div>
                                    <div style={{ color: "white", backgroundColor: "#419341", fontSize: "9px", padding: "1px 5px", borderRadius: "5px" }}>{invoice.interval.duration}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="squiffed-dint app-new-invoice-squiffed-dint">
                {/* <div className="header">
                    {selectedInvoice.customer.firstname} {selectedInvoice.customer.lastname}
                </div> */}
                <div className="settings">
                    <div onClick={() => navigate("/accounting/recurring-invoice/edit/" + selectedInvoice.hash)}>Edit</div>
                    {/* <div onClick={() => navigate("/accounting/invoices/create/" + selectedInvoice.hash)}>Send e-mail</div>
                    <div className={previewLoading === "share" ? "loading" : undefined} onClick={() => handleShare()}>Share</div>
                    <div className={previewLoading === "download" ? "loading" : undefined} onClick={() => generatePreview(true)}>Download PDF</div> */}
                </div>
                <div className="boater-side">
                    <div className="unfused-kay">
                        <div>
                            <div className="regrout-sue">
                                <div>
                                    <img src={DefaultProfile} alt="" />
                                </div>
                                <div className="regrout_sue_content">
                                    <div class="customer-deatils">{selectedInvoice.customer.firstname} {selectedInvoice.customer.lastname}</div>
                                    <div className="customer-deatils-email">{selectedInvoice.customer.email}</div>
                                    <div className="customer-details-phone">
                                        <FaPhone />
                                        {selectedInvoice.customer.phone}
                                    </div>
                                </div>
                            </div>
                            <div className="invoice_amount">
                                <div className="customer_details">INVOICE AMOUNT</div>
                                <div style={{ display: "flex", alignItems: "center", marginTop: "05px" }}>
                                    <div className="invoice__amount">{selectedInvoice.customer.currency.icon}{currencyFormat(total)}</div>
                                </div>
                            </div>
                            <div className="invoice_amount">
                                <div className="customer_details">DETAILS</div>
                                <div style={{ display: "flex", marginBottom: "20px" }}>
                                    <div className="customer_detailss" style={{ width: "140px" }}>Invoice Status</div>
                                    {selectedInvoice.active ? (
                                        <div>
                                            <div className="active_details">Active</div>
                                            <div className="make_as_active" onClick={() => handleToggleStatus(false)}>Mark as In-active</div>
                                        </div>
                                    ) : <div>
                                        <div className="in_active_details">In Active</div>
                                        <div className="make_as_active" onClick={() => handleToggleStatus(true)}>Mark as Active</div>
                                    </div>}
                                </div>
                                <div className="invoice_amount invoice_amount-2">
                                    <div className="customer_detailss" style={{ width: "140px" }}>Start Date</div>
                                    <div className="customer_detailss" style={{ fontSize: "12px" }}>{new Date(selectedInvoice.startdate).toDateString()}</div>
                                </div>
                                <div className="invoice_amount invoice_amount-2">
                                    <div className="customer_detailss" style={{ width: "140px" }}>End Date</div>
                                    <div className="customer_detailss" style={{ fontSize: "12px" }}>{selectedInvoice.expirydate ? new Date(selectedInvoice.expirydate).toDateString() : "Never Expires"}</div>
                                </div>
                                <div className="invoice_amount invoice_amount-2">
                                    <div className="customer_detailss" style={{ width: "140px" }}>Next Invoice</div>
                                    {selectedInvoice.nextgenerate ? <div className="customer_detailss" style={{ fontSize: "12px" }}>{new Date(selectedInvoice.nextgenerate).toDateString()}</div> : <div style={{ backgroundColor: "rgb(227, 83, 83)", color: "white", padding: "2px 6px", fontSize: "12px" }}>Expired</div>}
                                </div>
                                <div className="invoice_amount invoice_amount-2">
                                    <div className="customer_detailss" style={{ width: "140px" }}>Repeat</div>
                                    <div className="customer_detailss" style={{ fontSize: "12px" }}>
                                        {selectedInvoice.interval.duration}
                                        {selectedInvoice.interval.duration === "Custom" ? (
                                            <span style={{ backgroundColor: "rgb(218, 218, 218)", marginLeft: "8px", padding: "4px 8px" }}>
                                                {selectedInvoice.interval.customduration} {selectedInvoice.interval.custom}
                                            </span>
                                        ) : undefined}
                                    </div>
                                </div>
                            </div>
                            <div className="invoice_amount">
                                <div  className="customer_details">CUSTOMER NOTES</div>
                                <div  className="customer_detailss">
                                    <div>{selectedInvoice.note}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="airbeds-saw">
                        <div className="lempira-pug">
                            Generated Invoices
                        </div>
                        {loading ? (
                            <div className="bedumbed-and oleas-oft">
                                <SpinnerCircular size="70" color="#3b70ad" />
                            </div>
                        ) : (
                            <div className="oleas-oft">
                                {generatedInvoices.length ? generatedInvoices.map((invoice) => {
                                    return (
                                        <div className="welch-tuft" onClick={() => navigate(`/accounting/invoices?hash=${invoice.hash}`)}>
                                            <div className="superb-icy">
                                                <div>INV-{String(invoice.invoiceindex).padStart(6, "0")}</div>
                                                <div className="isles-tom">{invoice.customer.currency.icon}{total}</div>
                                            </div>
                                            <div className="earths-hat">
                                                <div>Generated on</div>
                                                <div>{new Date(invoice.invoicedate).toDateString()}</div>
                                            </div>
                                        </div>
                                    )
                                }) : <div>No invoice generated</div>}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RecurringInvoiceList
